import { pSBC, lightOrDark } from "./newShade";

export const makeOppositeShade = color => {
  return lightOrDark(color) === "dark" ? pSBC(-0.4, color) : pSBC(0.3935, color);
};

export const makeShade = color => {
  return lightOrDark(color) === "dark" ? pSBC(0.3935, color) : pSBC(-0.4, color);
};

export const makeOppositeShadeStronger = color => {
  return lightOrDark(color) === "dark" ? pSBC(-0.9, color) : pSBC(0.8935, color);
};
